import gql from 'graphql-tag';

const UPDATE_MANUAL_DISPOSITION = gql`
  mutation updateManualDisposition(
    $eventExternalId: String!
    $manualDispositionReasonId: Int!
    $manualDispositionComment: String
  ) {
    updateManualDisposition(
      eventExternalId: $eventExternalId
      manualDispositionReasonId: $manualDispositionReasonId
      manualDispositionComment: $manualDispositionComment
    ) {
      message
      eventExternalId
      manualDispositionReasonId
    }
  }
`;

export default UPDATE_MANUAL_DISPOSITION;
